import type { MailRibbonConfigStore } from "../types/mailRibbonConfigStore";

export function fillMissingRibbonTabs(ribbonConfig: MailRibbonConfigStore, defaultRibbonConfig: MailRibbonConfigStore): MailRibbonConfigStore {
    return {
        ...ribbonConfig,
        multiline: {
            ...defaultRibbonConfig.multiline,
            ...ribbonConfig.multiline,
        },
        singleline: {
            ...defaultRibbonConfig.singleline,
            ...ribbonConfig.singleline,
        },
    };
}
